export enum SpinAndHoldState
{
	Idle,
	IntroTransition,
	IntroMessage,
	MultiplierShow,
	WaitFirstSpin,
	//Running,
	Spin,
	Features,
	BigWin,
	Win,
	Bonus,
	Collect,
	SpinIdle,

	CometCollect,
	FinalMessage,
}